import { CodeItem } from '@/services/commonCode/types'

/**
 * 물류카테고리 코드를 '카테고리명 (코드)' 로 바꾸는 함수를 만든다.
 * 등록 모달·검색 필터·목록 그리드가 같은 표기를 쓰게 하려는 것이다.
 * 이름을 못 찾으면(응답 도착 전·폐기 코드) 코드를 그대로 돌려준다 — 값이 있는데 빈 칸으로 보이지 않게.
 */
export const createCategoryLabeler = (categories: CodeItem[] = []) => {
  const nameByCode = new Map(categories.map((category) => [category.code, category.name]))

  return (code: string) => {
    const name = nameByCode.get(code)
    return name ? `${name} (${code})` : code
  }
}
